import { frontendURL } from '../../../../helper/URLHelper';
import { ROUTE_ACCESSIBILITY } from '../../../../helper/routeHelpers';
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/ai-config'),
      name: 'ai_config',
      meta: {
        permissions: ['administrator'],
        onlyFor: ROUTE_ACCESSIBILITY.PHOENIX,
      },
      component: Index,
    },
  ],
};
